import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  ActivityIndicator,
  TouchableOpacity,
} from "react-native";
import { useNavigate } from "react-router-dom";
import { collection, query, orderBy, getDocs } from "firebase/firestore";
import { db } from "../firebase.config";
import { getCollectionPath } from "../utils/dbPaths";
import AuthHeader from "../components/AuthHeader";
import { useAuthStore } from "../stores";

const ViewBugReports = () => {
  const navigate = useNavigate();
  const [bugReports, setBugReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  useEffect(() => {
    loadBugReports();
  }, []);

  const loadBugReports = async () => {
    setLoading(true);
    try {
      const bugReportPath = getCollectionPath("bugreport");
      const q = query(
        collection(db, bugReportPath),
        orderBy("submittedAt", "desc")
      );

      const querySnapshot = await getDocs(q);
      const reports = [];

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        reports.push({
          id: doc.id,
          text: data.text || "",
          submittedBy: data.submittedBy || "Unknown",
          submittedAt: data.submittedAt?.toDate() || new Date(),
          userId: data.userId || null,
        });
      });

      setBugReports(reports);
    } catch (error) {
      console.error("Error loading bug reports:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return "Unknown date";
    try {
      return date.toLocaleString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    } catch (e) {
      return "Invalid date";
    }
  };

  return (
    <View style={styles.container}>
      <AuthHeader
        title="Bug Reports"
        subtitle=""
        isDesktop={window.innerWidth >= 768}
        isAuthenticated={isAuthenticated}
        shopInfo={{}}
        storeLogo=""
      />
      <ScrollView style={styles.scrollView} contentContainerStyle={styles.scrollContent}>
        <View style={styles.content}>
          <TouchableOpacity dataSet={{ hover: "lift" }}
            style={styles.backButton}
            onPress={() => navigate(-1)}
          >
            <Text style={styles.backButtonText}>← Back</Text>
          </TouchableOpacity>

          {loading ? (
            <View style={styles.loadingContainer}>
              <ActivityIndicator size="large" color="#0E7C6B" />
              <Text style={styles.loadingText}>Loading bug reports...</Text>
            </View>
          ) : bugReports.length === 0 ? (
            <View style={styles.emptyContainer}>
              <Text style={styles.emptyText}>No bug reports found.</Text>
            </View>
          ) : (
            bugReports.map((report) => (
              <View key={report.id} style={styles.reportCard}>
                <View style={styles.reportHeader}>
                  <Text style={styles.reportUser}>{report.submittedBy}</Text>
                  <Text style={styles.reportDate}>
                    {formatDate(report.submittedAt)}
                  </Text>
                </View>
                <Text style={styles.reportText}>{report.text}</Text>
              </View>
            ))
          )}
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F6F8F7",
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    padding: 16,
  },
  content: {
    maxWidth: 800,
    alignSelf: "center",
    width: "100%",
  },
  backButton: {
    marginBottom: 16,
    paddingVertical: 8,
    paddingHorizontal: 12,
    alignSelf: "flex-start",
  },
  backButtonText: {
    fontSize: 16,
    color: "#0E7C6B",
    fontWeight: "600",
  },
  loadingContainer: {
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 40,
  },
  loadingText: {
    marginTop: 12,
    fontSize: 16,
    color: "#5C6B68",
  },
  emptyContainer: {
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 40,
  },
  emptyText: {
    fontSize: 16,
    color: "#5C6B68",
  },
  reportCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 6,
    padding: 16,
    marginBottom: 16,
    boxShadow: "0 1px 2px rgba(15, 26, 25, 0.06), 0 2px 8px rgba(15, 26, 25, 0.06)",
    elevation: 3,
  },
  reportHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: "#DDE3E2",
  },
  reportUser: {
    fontSize: 16,
    fontWeight: "600",
    color: "#2E3A38",
  },
  reportDate: {
    fontSize: 14,
    color: "#5C6B68",
  },
  reportText: {
    fontSize: 15,
    color: "#2E3A38",
    lineHeight: 22,
  },
});

export default ViewBugReports;







